import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'classCode-search-dialog',
    templateUrl: './classCode-search-dialog.component.html',
    providers: [DataService]
})
export class ClassCodeSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        this.objectType = 'DBQuery';
        this.model.criteria.Procedure_Name = 'epx_getclasscode';
        this.model.title = 'Select Class Code';

        this.model.criteria.Max = 500;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
